/* esm.sh - @radix-ui/react-collection@1.1.8 */
export * from "/*@radix-ui/react-collection@1.1.8/esnext/react-collection.mjs";
